import React, { useState } from "react";
import helpData from "../data/private/help.json";
import { NavLink } from "react-router-dom";
import { logActivity } from "../utils/activity";

export default function DashboardHelp() {
  const [activeIndex, setActiveIndex] = useState(0);
  const activeStep = helpData.steps[activeIndex];

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold text-slate-900">
          {helpData.title}
        </h1>
        <p className="mt-2 text-sm text-slate-600">{helpData.subtitle}</p>
      </div>

      <div className="card p-6">
        <div className="flex items-center justify-between text-xs text-slate-500">
          <span>
            {activeIndex + 1} / {helpData.steps.length}
          </span>
          <span>{activeStep.title}</span>
        </div>
        <div className="mt-4 h-2 rounded-full bg-slate-100">
          <div
            className="h-2 rounded-full bg-amber-500"
            style={{
              width: `${((activeIndex + 1) / helpData.steps.length) * 100}%`,
            }}
          />
        </div>
        <div className="mt-4">
          <p className="text-sm font-semibold text-slate-900">
            {activeStep.title}
          </p>
          <p className="mt-2 text-sm text-slate-600">
            {activeStep.description}
          </p>
          <NavLink className="btn btn-primary mt-4" to={activeStep.path}>
            {activeStep.title}
          </NavLink>
        </div>
        <div className="mt-4 flex flex-wrap gap-2">
          {helpData.steps.map((step, index) => (
            <button
              key={step.title}
              className={`btn ${
                index === activeIndex ? "btn-primary" : "btn-secondary"
              }`}
              onClick={() => {
                setActiveIndex(index);
                logActivity("help_step_select", { title: step.title });
              }}
            >
              {step.title}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
